module.exports = __webpack_public_path__ + "img/404-Illustration@2x.72188193.png";